
export default {
    namespaced: true,
    state: {
        dialog: false,
        dialogG: false,
        timers: [],
        timersGrupos: [],
        idTimerActivo: '',
        autoGuardado: false,
        horaGuardado: '',
        contieneTimerActivo: '',
        imputarTodos: false,
        cargarDatosDialog: false,
        timerNuevo: {},
        cerrarSesion: false,
        cantidadTimersTotal: 0,
        // cantidadTimersTotalCopia: 0,
        // errorGuardado: false,
        // ultimoTimer: false,
        // guardando: false
    },
    mutations: {
        SET_DIALOG(state, mostrar){
            state.dialog = mostrar;
        },
        SET_DIALOGG(state, mostrar){
            state.dialogG = mostrar;
        },
        SET_IDTIMERACTIVO(state, idTimerActivo){
            state.idTimerActivo = idTimerActivo;
        },
        SET_TIMERS(state, timers){
            state.timers = timers;
        },
        async SET_NUEVOTIMER(state, cliente){ //(state, timer)
            let timer = {
                idCliente: cliente.code,
                cliente: cliente.name,
                hora: 0,
                minuto: 0,
                segundo: 0,
                contacto: '',
                comentarios: '',
                contratos: {},
                observaciones: cliente.observaciones,
                comercialCliente: cliente.comercialEmail,
                invalido: false
            }
            let date = new Date;
            timer.fecha = date.getFullYear()+'-' + ((date.getMonth()+1) < 10 ? '0'+(date.getMonth()+1) : (date.getMonth()+1))+'-' + (date.getDate() < 10 ? '0'+date.getDate() : date.getDate());
            timer.horaInicio = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':' + (date.getMinutes() < 10 ? '0'+date.getMinutes() : date.getMinutes());     

            state.timerNuevo = timer;
            state.idTimerActivo = timer.idCliente;
        },
        SET_ELIMINARTIMER(state, timer){
            state.timers = state.timers.filter(t => t.id !== timer.id); // timers = a todos los timers menos el que le paso
        },
        SET_ELIMINARTIMERGRUPO(state, timer){
            state.timersGrupos = state.timersGrupos.filter(t => t.id !== timer.id); // timers = a todos los timers menos el que le paso
        },
        SET_AUTOGUARDADO(state, autoGuardado){
            state.autoGuardado = autoGuardado;
            //guardo la hora en la que hacemos el guardado
            let date = new Date;
            state.horaGuardado = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':' + (date.getMinutes() < 10 ? '0'+date.getMinutes() : date.getMinutes());
        },
        SET_TABCONTIMERACTIVO(state, tab){
            state.contieneTimerActivo = tab;
        },
        SER_IMPUTARTODOS(state, imputarTodos){
            state.imputarTodos = imputarTodos;
        },
        SET_TIMERSGRUPO(state, timers){
            state.timersGrupos = timers;
        },
        SET_NUEVOTIMERGRUPO(state, grupo){
            let timer = {
                idGrupo: grupo.id,
                grupo: grupo,
                hora: 0,
                minuto: 0,
                segundo: 0,
                contacto: '',
                comentarios: ''
            }
            let date = new Date;
            timer.fecha = date.getFullYear()+'-' + ((date.getMonth()+1) < 10 ? '0'+(date.getMonth()+1) : (date.getMonth()+1))+'-' + (date.getDate() < 10 ? '0'+date.getDate() : date.getDate());
            timer.horaInicio = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':' + (date.getMinutes() < 10 ? '0'+date.getMinutes() : date.getMinutes());
            state.timerNuevo = timer;
            // state.timersGrupos.unshift(timer);
            state.idTimerActivo = timer.idGrupo;
        },
        SET_CARGARDATOSDIALOG(state, cargar){
            state.cargarDatosDialog = cargar;
        },
        SET_SUMARCANTIDADTIMERSTOTAL(state){
            state.cantidadTimersTotal++;
        },
        SET_RESTARCANTIDADTIMERSTOTAL(state){
            state.cantidadTimersTotal--;
        },
        // SET_CANTIDADTIMERSTOTAL(state, valor){
        //     state.cantidadTimersTotal = valor;
        // },
        // SET_CANTIDADTIMERSTOTALCOPIA(state, valor){
        //     state.cantidadTimersTotalCopia = valor;
        // },
        SET_CERRARSESION(state, valor){
            state.cerrarSesion = valor;
        },
        // SET_ERRORGUARDADO(state, valor){
        //     state.errorGuardado = valor;
        // },
        // SET_GUARDANDO(state, valor){
        //     state.guardando = valor;
        // }
    },
    actions: {
        setDialog({commit}, mostrar){
            commit('SET_DIALOG', mostrar);
        },
        setDialogG({commit}, mostrar){
            commit('SET_DIALOGG', mostrar);
        },
        setIdTimerActivo({commit}, idTimerActivo){
            commit('SET_IDTIMERACTIVO', idTimerActivo);
        },
        setTimers({commit}, timers){
            commit('SET_TIMERS', timers);
        },
        setNuevoTimer({commit}, idCliente){
            commit('SET_NUEVOTIMER', idCliente);
        },
        setEliminarTimer({commit}, timer){
            commit('SET_ELIMINARTIMER', timer);
        },
        setEliminarTimerGrupo({commit}, timer){
            commit('SET_ELIMINARTIMERGRUPO', timer);
        },
        setAutoGuardado({commit}, autoGuardado){
            commit('SET_AUTOGUARDADO', autoGuardado);
        },   
        setImputarTodos({commit}, imputarTodos){
            commit('SER_IMPUTARTODOS', imputarTodos);
        },
        setTabConTimerActivo({commit}, tab){
            commit('SET_TABCONTIMERACTIVO', tab);
        },
        setTimersGrupo({commit}, timers){
            commit('SET_TIMERSGRUPO', timers);
        },
        setNuevoTimerGrupo({commit}, grupo){
            commit('SET_NUEVOTIMERGRUPO', grupo);
        },
        setCargarDatosDialog({commit}, cargar){
            commit('SET_CARGARDATOSDIALOG', cargar);
        },
        setSumarCantidadTimersTotal({commit}){
            commit('SET_SUMARCANTIDADTIMERSTOTAL');
        },
        setRestarCantidadTimersTotal({commit}){
            commit('SET_RESTARCANTIDADTIMERSTOTAL');
        },
        // setCopiaCantidadTimersTotal({commit}, valor){
        //     commit('SET_CANTIDADTIMERSTOTALCOPIA', valor);
        // },
        // setCantidadTimersTotal({commit}, valor){
        //     commit('SET_CANTIDADTIMERSTOTAL', valor);
        // },
        setCerrarSesion({commit}, valor){
            commit('SET_CERRARSESION', valor);
        },
        // setErrorGuardado({commit}, valor){
        //     commit('SET_ERRORGUARDADO', valor);
        // },
        // setGuardando({commit}, valor){
        //     commit('SET_GUARDANDO', valor);
        // }
    }
}